import React, {useEffect} from "react";
import {useTranslation} from "react-i18next";
import CssBaseline from "@mui/material/CssBaseline";
import MainLayout from "../../components/layout/MainLayout";
import PolicyPage from "../../components/policy-page";
import useGetPolicyPage from "../../api-manage/hooks/react-query/useGetPolicyPage";
import SEO from "../../components/seo";
import useConfigData from "../../hooks/useConfigData";
import SplashScreen from "../../splash-screen";

const Index = () => {
    const { configData, landingPageData, loading } = useConfigData();
    const { t } = useTranslation();
    const { data, isFetching, refetch } = useGetPolicyPage("/cancellation-policy");
    
    useEffect(() => {
        refetch();
    }, [refetch]);

    if (loading) {
        return <SplashScreen />;
    }

    return (
        <>
            <CssBaseline/>
            <SEO
                title={configData ? `Cancellation policy` : "Loading..."}
                image={`${configData?.base_urls?.business_logo_url}/${configData?.fav_icon}`}
                businessName={configData?.business_name}
            />
            <MainLayout configData={configData} landingPageData={landingPageData}>
                <PolicyPage
                    data={data}
                    title={t("Cancellation policy")}
                    isFetching={isFetching}
                />
            </MainLayout>
        </>
    );
};

export default Index;
